import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

export const EventRegisterSuccessModal = ({ isOpen, onClose, isUnregister }) => {
  return (
    <CustomModal
      title={isUnregister ? 'Ihre Abmeldung war erfolgreich.' : 'Ihre Anmeldung war erfolgreich.'}
      content={
        <div className="event-register-form__modal-content-wrapper">
          {isUnregister
            ? 'Sie wurden erfolgreich von der Veranstaltung abgemeldet.'
            : 'Sie erhalten in Kürze per E-Mail eine Bestätigung mit allen Veranstaltungsinformationen.'}
        </div>
      }
      ctaButtons={<ActionButton title="Schließen" onClick={onClose} inverted />}
      closeCancelEventModal={onClose}
      isOpen={isOpen}
    />
  );
};

EventRegisterSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isUnregister: PropTypes.bool,
};

EventRegisterSuccessModal.defaultProps = {
  isUnregister: false,
};
